import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-25fdbe18")

_pushScopeId("data-v-25fdbe18")
const _hoisted_1 = { style: {"width":"360px","display":"inline-block"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("复原")
const _hoisted_4 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_modal = _resolveComponent("a-modal")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form = _resolveComponent("a-form")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = $event)),
      title: "管理报表",
      width: "800px",
      maskClosable: false,
      keyboard: false,
      afterClose: _ctx.close,
      class: "config-modal",
      footer: null
    }, {
      default: _withId(() => [
        _createVNode(_component_a_table, {
          dataSource: _ctx.dataSource,
          columns: _ctx.dashboardColumns,
          "row-key": (record) => record.code
        }, {
          url: _withId(({ text }) => [
            _createVNode("a", _hoisted_1, _toDisplayString(text), 1)
          ]),
          operation: _withId(({ record }) => [
            _createVNode(_component_a_button, {
              type: "link",
              style: {"margin-right":"10px"},
              onClick: ($event: any) => (_ctx.editPage(record))
            }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "link",
              onClick: ($event: any) => (_ctx.resetPage(record.code))
            }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "row-key"])
      ]),
      _: 1
    }, 8, ["visible", "afterClose"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.editVisible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.editVisible = $event)),
      title: "修改报表",
      onOk: _ctx.handleOk,
      width: "700px"
    }, {
      default: _withId(() => [
        (_ctx.editVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_a_form, null, {
                default: _withId(() => [
                  _createVNode(_component_a_form_item, { label: "名称" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.currentPage.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "url" }, {
                    default: _withId(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.currentPage.url,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentPage.url = $event)),
                        style: {"width":"500px"}
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ], 64))
})